// utils/tableConstants.js
export const PERMANENT_COLUMNS = [
  'jobReqId',
  'companyName',
  'jobTitle',
  'jobLocation',
  'jobReqStatus',
  'salary',
  'skillSet',
  'qualification',
  'passedOutYear',
  'bond',
  'experienceRequired',
  'interviewType',
  'totalSelectionCount',
  'numberOfOpenings',
  'createdAt',
  'createdBy',
];


export const ALL_COLUMNS = [
  { key: 'jobReqId', label: 'Job Requirement ID' },
  { key: 'companyName', label: 'Company Name' },
  { key: 'jobTitle', label: 'Job Title' },
  { key: 'jobLocation', label: 'Job Location' },
  { key: 'jobReqStatus', label: 'Job Requirement Status' },
  { key: 'salary', label: 'Salary' },
  { key: 'skillSet', label: 'Skill-Set' },
  { key: 'qualification', label: 'Qualification' },
  { key: 'passedOutYear', label: 'Passed out year' },
  { key: 'bond', label: 'Bond' },
  { key: 'experienceRequired', label: 'Experience' },
  { key: 'interviewType', label: 'Interview Type' },
  { key: 'totalSelectionCount', label: 'Total Selection Count' },  // ⬅️ ADD
  { key: 'numberOfOpenings', label: 'Number of Job Openings' },
  { key: 'createdAt', label: 'Created Date' },
  { key: 'createdBy', label: 'Created By' },
];